import { render } from "./DetailBody.vue?vue&type=template&id=6075afe3"
import script from "./DetailBody.vue?vue&type=script&lang=ts"
export * from "./DetailBody.vue?vue&type=script&lang=ts"
script.render = render

export default script